export const resolveStatementVersionPair = ({ row, auth, fallbackOfficialId, fetchFn, dispatch }) => {
  const targetOfficialId = (row && row.ownerId) || fallbackOfficialId;
  if (!targetOfficialId) {
    return Promise.reject(new Error("Neznámý funkcionář — nelze otevřít verzi oznámení."));
  }
  return fetchFn(`${auth.startUrl}/api/funkcionari/${targetOfficialId}/oznameni`, dispatch)
    .then((r) => r.json())
    .then((data) => {
      const items = (data && data.items) || [];
      const stmt = items.find((s) => s.id === row.entityId);
      const versions = ((stmt && stmt.statementVersions) || [])
        .slice()
        .sort((a, b) => new Date(b.versionDateTime) - new Date(a.versionDateTime));
      if (versions.length === 0) throw new Error("Verze oznámení nenalezena.");
      const rowTime = new Date(row.timestamp).getTime();
      let idx = 0;
      let best = Infinity;
      versions.forEach((v, i) => {
        const d = Math.abs(new Date(v.versionDateTime).getTime() - rowTime);
        if (d < best) {
          best = d;
          idx = i;
        }
      });
      return { targetOfficialId, versions, idx };
    });
};
